import { render, staticRenderFns } from "./scree.vue?vue&type=template&id=4636ee8c&scoped=true"
import script from "./scree.vue?vue&type=script&lang=js"
export * from "./scree.vue?vue&type=script&lang=js"
import style0 from "./scree.vue?vue&type=style&index=0&id=4636ee8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4636ee8c",
  null
  
)

export default component.exports